import React, { useState } from "react";
import salesImg from "../../assets/sales.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot, FaRegCreditCard } from "react-icons/fa"; // ✅ FIXED ICON

const styles = `
  .sales-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .sales-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .sales-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .sales-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .sales-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sales-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sales-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .sales-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .sales-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .sales-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .sales-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .sales-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .sales-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .sales-img-wrapper {
    flex: 1;
  }

  .sales-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .sales-accordion {
    flex: 1.2;
  }

  .sales-accordion-item {
    margin-bottom: 18px;
  }

  .sales-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .sales-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .sales-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .sales-header {
      height: auto;
      min-height: 90px;
    }

    .sales-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .sales-title-group h2 {
      font-size: 26px;
    }

    .sales-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .sales-header {
      flex-direction: column;
      height: auto;
    }

    .sales-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .sales-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .sales-triangle-left,
    .sales-triangle-right {
      width: 50px;
    }

    .sales-title-group h2 {
      font-size: 22px;
    }

    .sales-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .sales-img-wrapper {
      width: 100%;
    }

    .sales-img-wrapper img {
      max-width: 100%;
    }

    .sales-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .sales-header {
      flex-direction: column;
      height: auto;
    }

    .sales-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .sales-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .sales-header-badge span:first-of-type {
      font-size: 12px;
    }

    .sales-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .sales-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .sales-triangle-left,
    .sales-triangle-right {
      width: 36px;
    }

    .sales-title-group h2 {
      font-size: 18px;
    }

    .sales-title-group svg {
      font-size: 22px !important;
    }

    .sales-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .sales-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .sales-accordion-arrow {
      font-size: 18px;
    }

    .sales-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .sales-title-group h2 {
      font-size: 15px;
    }

    .sales-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function SalesPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    { title: "1.Sales Forecasting", content: "AI Robotically predicts sales precisely based on the customer contacts and earlier sales results." },
    { title: "2.Lead generation", content: "AI Create leads for the sales reps leveraging databases and social networks" },
    { title: "3.Sales Data Input Automation", content: "AI bots easily and logically sync calendar, address book, emails, phone calls, and messages of the Salesforce to the CRM system." },
    { title: "4.Predictive sales/lead scoring", content: "Artificial Intelligence leads to prioritize sales rep actions based on lead scores and contact factors." },
    { title: "5.Sales Chatbot", content: "AI Chatbots assist customers and automate conversations." },
    { title: "6.AI-based agent coaching", content: "Both AI and emotion AI can be leveraged to train sales reps and client service employees" },
    { title: "7.Retail Sales Bot", content: "Bots helps to deliver the correct act depending on the characteristics and mimics of the customer." }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="sales-header">
        {/* LEFT */}
        <div
          className="sales-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="sales-header-overlay" />

          <div className="sales-header-badge">
            <div className="sales-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span className="sales-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="sales-header-right">
          {/* LEFT SHAPE */}
          <div className="sales-triangle-left" />

          {/* RIGHT SHAPE */}
          <div className="sales-triangle-right" />

          {/* ICON + TITLE */}
          <div className="sales-title-group">
            <FaRegCreditCard
              style={{
                fontSize: "28px",   // ✅ MATCH 2nd IMAGE
                color: "#2fb7a4"    // ✅ TEAL COLOR
              }}
            />
            <h2>Sales</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN ===== */}
      <div className="sales-main">
        {/* IMAGE */}
        <div className="sales-img-wrapper">
          <img src={salesImg} alt="Sales" />
        </div>

        {/* CONTENT */}
        <div className="sales-accordion">
          {data.map((item, i) => (
            <div key={i} className="sales-accordion-item">
              <div
                className="sales-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="sales-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="sales-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SalesPage;
